import Loadable from '@townsquare/loadable';

export const AgentViewLoadable = Loadable({
	loader: () => import(/* webpackChunkName: "agents-view" */ './AgentView'),
	loading: () => null,
});
